export class GhostUserDto {
    constructor(idKey, organizationCode) {
        this.idKey = idKey;
        this.organizationCode = organizationCode;
    }
}
